import { QuestionBase } from 'src/app/core/components/dynamic-form/models/question-base';
import { TIPOLOGIA_FILTER } from '../models/elaboration-doc-filter';
import { ElaborationDocumentListRequest } from '../models/elaboration-doc-list-request';

export const cardFilters: QuestionBase[] = [
    {
        key: 'titolo',
        label: 'Titolo',
        required: false,
        controlType: 'textbox',
        placeholder: 'Filtra per titolo',
        size: 'sm-3',
        type: 'text',
      },
      {
        key: 'stato',
        label: 'Stato',
        placeholder: 'Filtra per stato',
        options: [],
        size: 'sm-3',
        required: false,
        controlType: 'dropdown',
        type: '',
      },
      {
        key: 'dataCreazione',
        label: 'Data di Creazione',
        placeholder: 'Filtra per data riferimento',
        required: false,
        controlType: 'date',
        size: 'sm-3',
        type: 'text',
      }
]


export const defaultFilterBody: ElaborationDocumentListRequest = {
  parameters:{},
  paging:{
     'from-row':0,
     'max-rows-x-page':10,
     orders:[
        {
          fieldEntityName:'dataCreazione',
          orderClause:'DESC'
        }
     ]
  },
  cntParam:0
}


export const formConfig = {
  buttons: [
    {
      bg: '',
      width: '',
      type: 'reset',
      title: 'Reset',
      size: 'sm-6',
      class: 'btn-outline-secondary',
    },
    {
      bg: '',
      width: '',
      type: 'submit',
      title: 'Cerca',
      size: 'sm-6',
      class: 'btn-primary',
    },
  ],
};

export const highlightTagConfig = {
  [TIPOLOGIA_FILTER.TOPIC]: {
    tag: '<span class="topic">$</span>',
    lenghtBefore: 20,
    lenghtAfter: 7
  },
  [TIPOLOGIA_FILTER.ENTITY]: {
    tag: '<span class="entity">$</span>',
    lenghtBefore: 21,
    lenghtAfter: 7
  },
  [TIPOLOGIA_FILTER.SEZIONE]: {
    tag: '<span class="sezione">$</span>',
    lenghtBefore: 22,
    lenghtAfter: 7
  }
}
